// When adding new supported text file types below,
// please also add them to TEXT_TYPES as these are not detectable
export const TEXT_TYPES = ['csv', 'json', 'md', 'svg', 'txt'] as const;

// Filetypes we can detect by looking at the file's bytes
// https://en.wikipedia.org/wiki/List_of_file_signatures

export const SUPPORTED_IMAGE_TYPES = {
  jpeg: /^ffd8ff(c[024]|d[abd]|e|fe)/i,
  jpg: /^ffd8ff(c[024]|d[abd]|e|fe)/i,
  png: /^89504e470d0a1a0a/i,
  gif: /^47494638(3761|3961)/i,
  webp: /^52494646(.*)57454250/i,
  avif: /^(.*){8}66747970617669(66|73)/i, // this is "ftypavif" (61766966) (or "ftypavis", 61766973) encoded in hex
  bmp: /^424d/i,
  svg: /./,
} as const;

// Note: Keep this in sync with SUPPORTED_DOCUMENT_MIMETYPES below
// Read more about file signatures: https://en.wikipedia.org/wiki/List_of_file_signatures
export const SUPPORTED_DOCUMENT_TYPES = {
  pdf: /^25504446/i,
  doc: /^d0cf11e0a1b11ae1/i,
  xls: /^d0cf11e0a1b11ae1/i,
  ppt: /^d0cf11e0a1b11ae1/i,
  docx: /^504b(0304|0506|0708)/i,
  xlsx: /^504b(0304|0506|0708)/i,
  pptx: /^504b(0304|0506|0708)/i,
  txt: /./,
  csv: /./,
  odt: /^504b(0304|0506|0708)/,
  ods: /^504b(0304|0506|0708)/,
  odp: /^504b(0304|0506|0708)/,
  json: /./,
  md: /./,
  lottie: /^504b(0304|0506|0708)/, // .lottie is based off zip file format
  riv: /^52495645/i,
  zip: /^504b(0304|0506|0708)/i,
} as const;

export const SUPPORTED_AUDIO_TYPES = {
  mp3: /^(494433|fff[23b])/i,
  ogg: /^4f676753/i,
} as const;

export const SUPPORTED_VIDEO_TYPES = {
  webm: /^1a45dfa3/i,
  mp4: /^.{8}66747970(336770|4d344120|69736f6d|71742020|6d703432)/i,
  mov: /^.{8}6674797071742020/i,
  ogg: /^4f676753/i,
} as const;

// Corresponds to longest item in FILE_DETECTION_REGEX_MAP
//   - Currently it is mp4 and mov which is 12 bytes when treated as hex.
//   - Used in backend code for determining how much of the file needs to be
//     converted to hex before comparing
export const MAGIC_BYTE_DETECTION_BYTE_LENGTH = 12;

// Max file size in MB
export const MAX_IMAGE_ASSET_SIZE = 4;
export const MAX_DOCUMENT_ASSET_SIZE = 10;
export const MAX_VIDEO_ASSET_SIZE = 30;
export const MAX_AUDIO_ASSET_SIZE = 4;
export const MAX_ASSET_NAME_LENGTH = 100;

export const MAX_ZIP_ASSET_SIZE_CANVAS = 25;
export const MAX_AUDIO_ASSET_SIZE_CANVAS = 10;

export const MAX_LLMS_SIZE_MB = 4;
export const MAX_LLMS_SIZE_BYTES = MAX_LLMS_SIZE_MB * 1024 * 1024;

// Max file size in kb
export const MAX_IMAGE_ASSET_SIZE_KB = 4096; /* 4096 kilobytes === 4 megabytes */

export const MAX_ASSETS_PER_REQUEST = 100;

export const EXTENSION_NORMALIZATION_MAP = {
  jpeg: 'jpg',
} as const;

// Filetypes we can generate thumbnails for via prism
// Note: prism may support more formats than asset manager via upload.
// This is to support people who uploaded them either before the current
// restrictions or via some other means or association.
export const COMPAT_THUMB_REGEX = /(\.(jpg|jpeg|png|gif|avif))$/i;

// Filetypes we can get dimensions for via prism
export const COMPAT_DIMENSIONS_REGEX =
  /\.(jpg|jpeg|png|bmp|gif|svg|webp|avif)$/i;

// Filetypes allowed to be used for the OG Image url field in page settings
export const OG_ASSET_ALLOWED_IMAGE_TYPES = ['png', 'jpg', 'jpeg'];
